<template>
	<v-layout class="mega-menu-mobile">
		<v-navigation-drawer
			v-model="isMobileMenuOpen"
			:width="width"
			touchless
			temporary
			location="right"
			class="mega-menu-mobile__drawer-container">
			<v-window v-model="tab" class="profile-menu__tab-content">
				<v-window-item value="menu">
					<div class="mega-menu-mobile__content">
						<div class="mega-menu-mobile__buttons-container">
							<ClientOnly>
								<LazyIdleGlobalLanguageSelect big hydrate-on-idle />
								<LazyIdleCurrencySelect hydrate-on-idle />
							</ClientOnly>
						</div>
						<div class="mega-menu-mobile__menu mega-menu-mobile__menu--main">
							<ButtonCustom
								v-for="(item, index) in computedNav"
								:key="index"
								:to="item.newTab === true || item.type === 'link-dropdown' ? undefined : localePath(item.to)"
								:href="item.newTab === true ? item.to : undefined"
								class="mega-menu-mobile__main-menu-link"
								:target="item.newTab === true ? '_blank' : ''"
								@click="
									item.type === 'dropdown' ? (tab = 'mega_menu') : item.type === 'link-dropdown' ? (tab = 'cars_menu') : undefined
								">
								<div>
									{{ i18nService.$tDynamic('components.nav', item.translation_key_label || item.label) }}
								</div>
								<GlobalIcon
									v-if="item.type === 'dropdown' || item.type === 'link-dropdown'"
									name="arrow-right"
									:height="18"
									:width="18"
									class="mega-menu-mobile__menu-link-icon" />
							</ButtonCustom>
							<div class="mega-menu-mobile__ratings-and-buttons">
								<div class="mega-menu-mobile__socials-container">
									<div class="mega-menu-mobile__fb-ig">
										<NuxtLink
											class="mega-menu-mobile__social-container"
											to="https://www.facebook.com/CarFree.Wypozyczalnia.Aut"
											rel="nofollow"
											target="_blank"
											aria-label="CarFree na Facebooku">
											<GlobalIcon name="facebook" :height="24" :width="24" color="var(--primary-color)" />
										</NuxtLink>
										<NuxtLink
											class="mega-menu-mobile__social-container"
											to="https://www.instagram.com/carfree.wypozyczalnia"
											rel="nofollow"
											target="_blank"
											aria-label="CarFree na Instagramie">
											<GlobalIcon name="instagram" :height="24" :width="24" color="var(--primary-color)" />
										</NuxtLink>
										<NuxtLink
											class="mega-menu-mobile__social-container"
											to="https://www.tiktok.com/@carfree.pl"
											rel="nofollow"
											target="_blank"
											aria-label="CarFree na TikToku">
											<GlobalIcon name="tiktok" :height="24" :width="24" color="var(--primary-color)" />
										</NuxtLink>
									</div>
									<NuxtLink
										v-if="ratingsForm.stars && ratingsForm.stars !== ''"
										class="mega-menu-mobile__google-container"
										:to="ratingsForm?.url"
										rel="nofollow"
										target="_blank">
										<div class="mega-menu-mobile__social-container">
											<GlobalIcon name="google-logo" :height="24" :width="24" />
										</div>
										<div class="mega-menu-mobile__ratings-box">
											<div class="mega-menu-mobile__ratings">
												<div class="mega-menu-mobile__rating-text">{{ formatRating(ratingsForm.ratings) }}</div>
												<div class="mega-menu-mobile__rating-stars">
													<GlobalRating
														:rating="ratingsForm.stars"
														readonly
														colorFilled="var(--primary-color)"
														colorEmpty="var(--primary-color)"></GlobalRating>
												</div>
											</div>
											<div class="mega-menu-mobile__google-and-amount">
												<div class="mega-menu-mobile__google-text">Google,</div>
												<div class="mega-menu-mobile__google-amount">
													{{ ratingsForm.ratingsCount }} {{ $t('components.booker.google_reviews.opinions') }}
												</div>
											</div>
										</div>
									</NuxtLink>
									<NuxtLink
										v-if="trustpilotRatingsForm.stars && trustpilotRatingsForm.stars !== ''"
										class="mega-menu-mobile__google-container"
										:to="trustpilotRatingsForm.url"
										rel="nofollow"
										target="_blank">
										<div class="mega-menu-mobile__social-container">
											<GlobalIcon name="trustpilot-icon" :height="24" :width="24" />
										</div>
										<div class="mega-menu-mobile__ratings-box">
											<div class="mega-menu-mobile__ratings">
												<div class="mega-menu-mobile__rating-text">{{ formatRating(trustpilotRatingsForm.ratings) }}</div>
												<div class="mega-menu-mobile__rating-stars">
													<GlobalRating
														:rating="trustpilotRatingsForm.stars"
														readonly
														colorFilled="#00B67A"
														colorEmpty="#00B67A" />
												</div>
											</div>
											<div class="mega-menu-mobile__google-and-amount">
												<div class="mega-menu-mobile__google-text">Trustpilot,</div>
												<div class="mega-menu-mobile__google-amount">
													{{ trustpilotRatingsForm.ratingsCount }} {{ $t('components.booker.google_reviews.opinions') }}
												</div>
											</div>
										</div>
									</NuxtLink>
								</div>
								<div class="mega-menu-mobile__buttons">
									<ButtonPrimary class="mega-menu-mobile__start-reservation-btn" :to="localePath('cars')">
										{{ $t('components.mega_menu.mobile.start_reservation') }}
									</ButtonPrimary>
								</div>
							</div>
						</div>
					</div>
				</v-window-item>
				<v-window-item value="mega_menu">
					<div class="mega-menu-mobile__content">
						<div class="mega-menu-mobile__back-container">
							<button class="mega-menu-mobile__back-btn" @click="handleBack">
								<GlobalIcon name="arrow-left" :height="14" :width="14" class="mega-menu-mobile__back-icon" />
								<div class="mega-menu-mobile__back-text">{{ $t('components.mega_menu.mobile.back') }}</div>
							</button>
						</div>
						<div class="mega-menu-mobile__menu">
							<template v-for="(section, l) in computedMenu" :key="l">
								<div v-if="l !== 0" class="mega-menu-mobile__divider"></div>
								<div class="mega-menu-mobile__menu-title">
									{{ section.title }}
								</div>
								<div class="mega-menu-mobile__menu-links">
									<div v-for="(menuItem, j) in computedMenu[l].items" :key="j" class="mega-menu-mobile__menu-link-container">
										<ButtonCustom
											:to="menuItem?.link && !menuItem?.items && !menuItem?.menu ? localePath(menuItem?.link) : undefined"
											class="mega-menu-mobile__menu-link"
											@click="handleSubmenu(menuItem)">
											<GlobalIcon
												v-if="menuItem.icon"
												:name="menuItem.icon"
												:height="18"
												:width="18"
												color="var(--primary-color)"
												class="mega-menu-mobile__menu-link-main-icon" />
											<div class="mega-menu-mobile__menu-link-info">
												<div class="mega-menu-mobile__menu-link-text">
													{{ menuItem.title }}
												</div>
												<div v-if="menuItem.subText" class="mega-menu-mobile__menu-link-subtext">
													{{ menuItem.subText }}
												</div>
											</div>
											<GlobalIcon
												v-if="(menuItem.items && menuItem.items.length > 0) || menuItem.menu"
												name="arrow-right"
												:height="18"
												:width="18"
												class="mega-menu-mobile__menu-link-icon" />
										</ButtonCustom>
									</div>
								</div>
							</template>
						</div>
					</div>
				</v-window-item>
				<v-window-item value="cars_menu">
					<div class="mega-menu-mobile__content">
						<div class="mega-menu-mobile__back-container">
							<button class="mega-menu-mobile__back-btn" @click="handleBack">
								<GlobalIcon name="arrow-left" :height="14" :width="14" class="mega-menu-mobile__back-icon" />
								<div class="mega-menu-mobile__back-text">{{ $t('components.mega_menu.mobile.back') }}</div>
							</button>
						</div>
						<div class="mega-menu-mobile__menu">
							<div class="mega-menu-mobile__menu-title">
								{{ $t('modules.cars_module.cars.filters.vehicle_category') }}
							</div>
							<div class="mega-menu-mobile__menu-links">
								<div v-for="group in carsGroups" :key="group.id" class="mega-menu-mobile__menu-link-container">
									<ButtonCustom
										:to="localePath({ name: 'cars', query: { group: group.name } })"
										class="mega-menu-mobile__menu-link"
										@click="handleCarsGroupClick">
										<div class="mega-menu-mobile__menu-link-info">
											<div class="mega-menu-mobile__menu-link-text">
												{{ i18nService.$tDynamic('data.group_map_translations', groupMapTranslations[group.name]) }}
											</div>
										</div>
									</ButtonCustom>
								</div>
							</div>
						</div>
					</div>
				</v-window-item>
				<v-window-item value="sub_items">
					<div class="mega-menu-mobile__content">
						<div class="mega-menu-mobile__back-container">
							<button class="mega-menu-mobile__back-btn" @click="handleBack">
								<GlobalIcon name="arrow-left" :height="14" :width="14" class="mega-menu-mobile__back-icon" />
								<div class="mega-menu-mobile__back-text">{{ $t('components.mega_menu.mobile.back') }}</div>
							</button>
						</div>
						<div v-if="selectedMenuItem" class="mega-menu-mobile__menu">
							<div class="mega-menu-mobile__menu-link-container">
								<ButtonCustom :to="localePath(selectedMenuItem?.link) || undefined" class="mega-menu-mobile__menu-link">
									<div class="mega-menu-mobile__menu-link-info">
										<div class="mega-menu-mobile__submenu-link-text">
											{{ selectedMenuItem.title }}
										</div>
									</div>
								</ButtonCustom>
							</div>

							<div class="mega-menu-mobile__menu-links mega-menu-mobile__menu-links--subitems">
								<div v-for="(menuItem, j) in selectedMenuItem.items" :key="j" class="mega-menu-mobile__menu-link-container">
									<ButtonCustom
										:to="menuItem?.link ? localePath(menuItem?.link) : undefined"
										class="mega-menu-mobile__menu-link"
										@click="handleSubitemClick(menuItem)">
										<div class="mega-menu-mobile__menu-link-info">
											<div class="mega-menu-mobile__submenu-link-text">
												{{ menuItem.title }}
											</div>
										</div>
									</ButtonCustom>
								</div>
								<template v-if="areCustomItems(selectedMenuItem.translation_key_title)">
									<div v-for="menuItem in customItems" :key="menuItem.to" class="mega-menu-mobile__menu-link-container">
										<ButtonCustom
											:to="menuItem.to || undefined"
											class="mega-menu-mobile__menu-link"
											@click="handleSubitemClick(menuItem)">
											<div class="mega-menu-mobile__menu-link-info">
												<div class="mega-menu-mobile__submenu-link-text">
													{{
														i18nService.$tDynamic(
															'components.nav.mega_menu',
															menuItem.translation_key_title || menuItem.title || '',
														)
													}}
												</div>
											</div>
										</ButtonCustom>
									</div>
								</template>
							</div>
						</div>
					</div>
				</v-window-item>
			</v-window>
		</v-navigation-drawer>
	</v-layout>
</template>

<script setup lang="ts">
import { useMegaMenu } from '../useMegaMenu'
import { nav } from '@/data/megaMenuData'

const tab = ref()
const isMobileMenuOpen = inject<Ref<boolean>>('isMobileMenuOpen') || ref(false)
const selectedMenuItem = ref<IMegaMenuItem | null>(null)
const i18nService = usei18nService()
const localePath = useLocalePath()
const { locale } = useI18n()
const googleRatingsStore = useGoogleRatingsStore()
const trustpilotRatingsStore = useTrustpilotRatingsStore()
const carsStore = useCarsStore()
const { width } = useWindowSize()

const carsGroups = computed<IProductGroupModel[]>(() => filterPublicGroups(carsStore.getAllGroups ?? []))

const handleCarsGroupClick = () => {
	isMobileMenuOpen.value = false
}

const { computedMenu, areCustomItems, getCustomItemsFor, handleRentalLengthFromLink, ensureLocationsLoaded } = useMegaMenu()

const computedNav = computed(() => {
	return nav.filter((item) => (item?.showOnlyOnPL ? locale.value === 'pl' : true))
})

const ratingsForm = reactive({
	stars: '',
	ratings: '',
	ratingsCount: '',
	url: '',
})

const trustpilotRatingsForm = reactive({
	stars: '',
	ratings: '',
	ratingsCount: '',
	url: '',
})

await Promise.all([googleRatingsStore.fetchGoogleRating(), trustpilotRatingsStore.fetchTrustpilotRating(), carsStore.fetchAllGroups()])

const customItems = computed(() => getCustomItemsFor(selectedMenuItem.value))

watch(
	() => googleRatingsStore.getGoogleRating,
	(v) => {
		if (v) {
			ratingsForm.stars = v.stars
			ratingsForm.ratings = v.ratings
			ratingsForm.ratingsCount = v.ratingsCount
			ratingsForm.url = v.url
		}
	},
	{ immediate: true },
)

watch(
	() => trustpilotRatingsStore.getTrustpilotRating,
	(v) => {
		if (v) {
			trustpilotRatingsForm.stars = v.stars
			trustpilotRatingsForm.ratings = v.ratings
			trustpilotRatingsForm.ratingsCount = v.ratingsCount
			trustpilotRatingsForm.url = v.url
		}
	},
	{ immediate: true },
)

const handleSubmenu = (menuItem: IMegaMenuItem) => {
	if ((menuItem.items && menuItem.items.length > 0) || menuItem.menu) {
		tab.value = 'sub_items'
		selectedMenuItem.value = menuItem
	} else {
		handleRentalLengthFromLink()
	}
}

const handleSubitemClick = (menuItem: IMegaMenuItem) => {
	handleRentalLengthFromLink(menuItem.link)
}

const handleBack = () => {
	if (selectedMenuItem.value) {
		tab.value = 'mega_menu'
		setTimeout(() => {
			selectedMenuItem.value = null
		}, 100)
	} else {
		tab.value = 'menu'
	}
}

watch(
	() => isMobileMenuOpen.value,
	async (newValue) => {
		if (!newValue) {
			tab.value = 'menu'
		}

		if (newValue) {
			await ensureLocationsLoaded()
		}

		if (!newValue) {
			document.body.style.overflow = 'unset'
		}
	},
	{ immediate: true },
)

onUnmounted(() => {
	tab.value = 'menu'
	isMobileMenuOpen.value = false
	document.body.style.overflow = 'unset'
})
</script>

<style lang="scss" src="./Mobile.scss"></style>
